module.exports = __webpack_public_path__ + "img/8.4f057171.png";